// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) {
  .container-wrapper {
    width: 767px;
    margin: 0 auto;
  }
  .unsubscribe-wrapper {
    width: 767px;
    margin: 0 auto;
  }
}
.loadingImage {
  transform: translate(-50%, -50%);
  position: fixed;
  top: 50%;
  left: 50%;
}

.incentive-form-conatiner {
  font-weight: 400;
  color: #4d4d4f;
  position: relative;
}
.incentive-form-conatiner .section-wrapper {
  height: 0;
}
.incentive-form-conatiner .incentive-banner {
  display: flex;
  padding: 0;
}
.incentive-form-conatiner .incentive-banner .incentive-banner-img {
  width: 100%;
  height: 266px;
}
.incentive-form-conatiner .container-wrapper {
  padding: 30px 20px 20px;
  opacity: 1;
  top: -46px;
  position: relative;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(3, 38, 68, 0.1);
  background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE;IACE,YAAA;IACA,cAAA;EACF;EACA;IACE,YAAA;IACA,cAAA;EACF;AACF;AAEA;EACE,gCAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AAAF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,SAAA;AAEJ;AAAE;EACE,aAAA;EACA,UAAA;AAEJ;AADI;EACE,WAAA;EACA,aAAA;AAGN;AAAE;EACE,uBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EAEA,mBAAA;EACA,6CAAA;EACA,yBAAA;AACJ","sourcesContent":["@media only screen and (min-width: 768px) {\n  .container-wrapper {\n    width: 767px;\n    margin: 0 auto;\n  }\n  .unsubscribe-wrapper {\n    width: 767px;\n    margin: 0 auto;\n  }\n}\n\n.loadingImage {\n  transform: translate(-50%, -50%);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n}\n.incentive-form-conatiner {\n  font-weight: 400;\n  color: #4d4d4f;\n  position: relative;\n  .section-wrapper {\n    height: 0;\n  }\n  .incentive-banner {\n    display: flex;\n    padding: 0;\n    .incentive-banner-img {\n      width: 100%;\n      height: 266px;\n    }\n  }\n  .container-wrapper {\n    padding: 30px 20px 20px;\n    opacity: 1;\n    top: -46px;\n    position: relative;\n\n    border-radius: 20px;\n    box-shadow: 0px 0px 10px rgba(3, 38, 68, 0.1);\n    background-color: #ffffff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
